import React from "react";
import { connect } from "react-redux";
import { Box } from "@mui/system";
import subfooter from "assets/images/subfooter.png";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { AppleStoreButton, PlayStoreButton } from "./PlayStoreButton";
import { handleBGColor } from "pages/home/CommonFunctions";

const SubFooterView = (props) => {
  const {
    organizationInfo: { app, colorSchemeJson, organizationOptionJson },
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const isShowBackgroundAssets =
    organizationOptionJson?.showBackgroundAssetsFlag?.toLowerCase() === "y";
  const widgetEnabled = sessionStorage.getItem("widgetEnabled");
  const isShowAppStoreBand =
    organizationOptionJson?.showAppStoreBand?.toLowerCase() === "y";

  if (isShowAppStoreBand) {
    return (
      <Box
        sx={{
          display: widgetEnabled?.toLowerCase() === "y" ? "none" : undefined,
          position: "relative",
          backgroundColor:
            app?.appCode !== "CVD"
              ? `${colorSchemeJson?.defaultColorScheme?.backgroundColor}  !important`
              : handleBGColor(app?.appCode),
        }}
      >
        <Box
          style={{
            width: "100%",
            height: matches ? "300px" : "100px",
            //marginBottom: 0.5,
          }}
        >
          {isShowBackgroundAssets && (
            <img
              src={subfooter}
              alt="sub footer"
              style={{
                width: "100%",
                height: matches ? "300px" : "100px",
                marginBottom: -4,
              }}
            />
          )}
        </Box>
        {isShowAppStoreBand && (
          <Box
            sx={{ position: "absolute", left: 0, top: 0, right: 0, bottom: 0 }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: matches ? "column" : "row",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box
                ml={matches ? "auto" : 4}
                mr={matches ? "auto" : 1}
                mb={matches ? 4 : undefined}
                mt={matches ? 4 : undefined}
              >
                <Typography
                  variant="h2LatoBlack"
                  sx={{
                    fontSize: "24px",
                    color: `${colorSchemeJson?.defaultColorScheme?.textColor}`,
                  }}
                >
                  DOWNLOAD
                </Typography>
                <br />
                <Typography
                  variant="h3LatoBlack"
                  sx={{
                    color: `${colorSchemeJson?.defaultColorScheme?.textColor}`,
                  }}
                >
                  the Cuverd app
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: matches ? "column" : "row",
                }}
              >
                <Box
                  sx={{
                    width: "220px",
                    zIndex: 1,
                    marginLeft: matches ? "auto" : undefined,
                    marginRight: matches ? "auto" : "24px",
                    marginBottom: matches ? "16px" : undefined,
                  }}
                >
                  <PlayStoreButton />
                </Box>
                <Box
                  sx={{
                    width: "220px",
                    marginLeft: matches ? "auto" : undefined,
                    marginRight: matches ? "auto" : undefined,
                  }}
                >
                  <AppleStoreButton />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data || {},
  };
};

export default connect(mapStateToProps)(SubFooterView);
